<template>
  <div class="sectionLogin">
    <dix class="content-container">
      <vs-row style="padding: 60px 30px">
        <vs-col vs-lg="12" vs-xs="12">
          <div class="container mt-1">
            <div>
              <b-img
                :src="require('@/assets/images/logo/sentenance_logo.png')"
                fluid
                alt="Fluid image"
              ></b-img>
            </div>
            <div v-if="this.$route.path == '/login'">
              <Login />
            </div>
            <div v-if="this.$route.path == '/Resetpassword'">
              <br />
              <Resetpassword />
            </div>
          </div>
        </vs-col>
        <div class="container footer">
          <footerlogin />
        </div>
      </vs-row>
    </dix>

    <!-- image-Login -->
    <div class="imge-container">
      <ImgContainer />
    </div>
  </div>
</template>

<script>
import Resetpassword from "./Resetpassword.vue";
import footerlogin from "./footerlogin.vue";
import Login from "./Login.vue";
import ImgContainer from "./ImgContainer.vue";

export default {
  components: {
    Resetpassword,
    footerlogin,
    Login,
    ImgContainer,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.sectionLogin {
  position: absolute;
  width: 100%;
  height: 100vh;
  display: flex;
  // top: 0;
  // left: 0;
  .content-container {
    // background-color: var(--background-color-sidebar);
    background-color: #fff;
    color: black;

    position: relative;
    width: 35%;
    height: 100%;
  }
  .imge-container {
    // background: var(--background-login);
    background: #f6f6f6;
    color: black;
    background-size: cover;
    height: 100vh;
    position: relative;
    width: 75%;
    // height: 100%;
  }
}
// @media screen and (max-width: 700px) {
//   #v {
//     display: inline;
//     padding: 0px;
//     right: -20px;
//   }
//   #b {
//     display: none;
//   }
//   #g {
//     display: none;
//   }
//   .imge-container {
//     display: none;
//     /* background: white; */
//     // background: var(--background-login);
//   }
//   .ale {
//     margin-top: 40px;
//   }
// }

@media only screen and (max-width: 1000px) {
  .sectionLogin {
    .imge-container {
      display: none;
    }
    .content-container {
      justify-content: center;
      display: flex;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }
}
/* Portrait */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {
  .sectionLogin {
    .imge-container {
      display: none;
    }
    .content-container {
      justify-content: center;
      display: flex;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }
}
.con-vs-dialog >>> .vs-dialog {
  width: 90%;
  max-width: 90%;
  max-height: 90%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.vuesax-app-is-ltr .con-vs-dialog .vs-dialog header .vs-dialog-cancel {
  display: none;
}
</style>